const applicationState = {
    mobile: false
};
export default applicationState;
